module.exports = __webpack_public_path__ + "static/media/file-edit.8eb54b30.svg";